import { Box } from "@mui/material"
import React from "react"
import { Document, Page } from "react-pdf"
import "./style.css";


function PdfViewer({pdf}) {
  return (
    <Box sx={{width:"100%",height:"50%"}}>
      {pdf && (
        <Document file={pdf} >
          <Page pageNumber={1} renderTextLayer={false} className={"react-pdf__Page__canvas"}
            renderAnnotationLayer={false}
            customTextRenderer={false}
          />
        </Document>
      )}</Box>
  )
}

export default PdfViewer